// extracted by mini-css-extract-plugin
module.exports = {"sizeToastify":"myAccount_sizeToastify__tpKmw"};